<template>
	<div class="am-about"
		:class="{ 'is-idle': !init }"
	>
		<div class="am-about__container">
			<div class="am-about__left">
				<am-text class="am-about__title" type="subtitle" v-html="title" />
				<am-text class="am-about__text" v-html="text" />
			</div>

			<div class="am-about__right">
				<am-gallery
					class="am-about__gallery"
					:images="images"
					@open="$emit('gallery', $event)"
				/>

				<div class="am-about__area">
					<am-icon name="pin" />
					<am-text class="am-about__total" type="subtitle">
						Área total de <b>340.000m²</b>
					</am-text>
				</div>

				<am-specs class="am-about__specs" />
			</div>
		</div>
	</div>
</template>

<script>
import AMIcon from '@/components/atoms/AMIcon'
import AMText from '@/components/atoms/AMText'
import AMGallery from '@/components/molecules/AMGallery'
import AMSpecs from '@/components/molecules/AMSpecs'
import { TweenMax, Power2 } from 'gsap/TweenMax'

export default {
	components: {
		'am-icon': AMIcon,
		'am-text': AMText,
		'am-gallery': AMGallery,
		'am-specs': AMSpecs,
	},

	props: {
		title: {
			type: String,
			default: 'Lorem ipsum<br /> dolor sit amet'
		},
		text: {
			type: String,
			default: 'Consectetur deleniti explicabo obcaecati vitae eaque. Voluptate necessitatibus nam minima consectetur quasi aut! Delectus laboriosam autem ipsum quibusdam aliquam. Ex.'
		},
		images: {
			type: Array,
			default: undefined
		},
		init: {
			type: Boolean,
			default: true
		}
	},

	watch: {
		init(value) {
			if (value)
				this.start()
		}
	},

	mounted() {
		if (this.init)
			this.start()
	},
	
	methods: {
		start() {
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-about__left > *, .am-about__right > *'), 1, {
				y: '40px',
				opacity: 0,
				ease: Power2.easeOut
			}, .3)
		}
	}
}
</script>

<style lang="scss">
.am-about{
	position: relative;
	background: white;
	z-index: 10;
	transition: .3s $easeInOutQuad;
	@include grid-container;
	&__container{
		// @include outer-container;
	}
	&__left,
	&__right{
		padding-top: 24px;
		@include grid-column(6);
	}
	&__right{
		display: flex;
		flex-flow: column;
		flex: 1;
	}
	&__title{
		margin-bottom: 24px;
	}
	&__gallery{
		background-size: 100%;
		background-repeat: no-repeat;
	}
	&__text{
	}
	&__area{
		padding: 0 4px;
		display: none;
		align-items: center;
		justify-content: flex-start;
		.am-icon{
			margin-right: 18px;
			font-size: 30px;
		}
		.am-text{
			font-size: 46px;
		}
	}
	&__specs{
	}

	&.is-idle{
		opacity: 0;
	}

	@include grid-media($smartphone-grid) {
		&__container{
			display: flex;
			flex-flow: column;
			height: 100%;
		}
		&__gallery{
			flex: .9;
			&:after{
				padding-top: 0;
			}
		}
		&__specs{
			width: 90%;
			margin: 16px auto;
		}
	}

	@include grid-media($tablet-grid) {
		&__container{
			display: flex;
			flex-flow: column;
			height: 100%;
		}
		&__gallery{
			flex: .9;
			&:after{
				padding-top: 0;
			}
		}
		&__specs{
			margin-top: 16px;
			margin-bottom: 16px;
		}
	}

	@include grid-media($desktop-grid) {
		display: flex;
		align-items: center;
		&:after{
			content: "";
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 50%;
			height: 100%;
			background: #F8F8F8;
			z-index: -1;
		}
		&__title{
			margin-bottom: 32px;
		}
		&__left{
			padding: 80px 0;
			@include grid-column(3, (columns: 10));
			@include grid-push(1, (columns: 10));
		}
		&__right{
			padding: 42px 0;
			@include grid-column(4, (columns: 10));
			@include grid-push(1, (columns: 7));
		}
		&__specs{
			height: 100px;
			padding: 42px 0;
		}
		&__area{
			display: flex;
		}
	}
}
</style>
